import * as React from 'react';

function SvgTickNo(props) {
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7 5.03L11.123.908a1.393 1.393 0 011.97 1.97L8.97 7l4.122 4.122a1.394 1.394 0 01-1.97 1.97L7 8.97l-4.123 4.122a1.393 1.393 0 01-1.97-1.97L5.03 7 .908 2.878a1.394 1.394 0 011.97-1.97L7 5.03z"
        fill="#8C8C8C"
      />
    </svg>
  );
}

export default SvgTickNo;
